export default "__VITE_ASSET__oMGaOy3r__"